import { AgGridService } from "@topline/services/agGridService";
import { ApiClient } from "@topline/services/apiService";
import { Gen } from "../../../Services/api";

export class ForecastGridService {
    static componentName = "forecastGridService";
    static $inject = [ApiClient.componentName, AgGridService.componentName];

    constructor(protected apiClient: ApiClient, protected agGridService: AgGridService) {}

    getDraftForecasts(filter: any) {
        return this.apiClient
            .getDraftForecasts(
                filter.page,
                filter.pageSize,
                filter.sortField,
                filter.sortType,
                filter.name,
                filter.marketName,
                filter.productManager,
                filter.modificationTime,
                filter.productCode,
                filter.budgetYear,
                filter.marketCountry
            )
            .then(response => {
                return response;
            });
    }

    createForecastDraftDataSource = (filterInstance: any) => {
        return this.agGridService.createDataSource(this.getDraftForecasts.bind(this), filterInstance);
    };

    getCreatedForecasts = (filter: any) => {
        return this.apiClient
            .getCreatedForecasts(
                filter.page,
                filter.pageSize,
                filter.sortField,
                filter.sortType,
                filter.name,
                filter.marketName,
                filter.productManager,
                filter.modificationTime,
                filter.productCode,
                filter.budgetYear,
                filter.marketCountry,
                filter.status,
                filter.marketType,
                filter.assignedPerson,
                filter.creationTime,
                filter.budgetVersionUId
            )
            .then(response => {
                return response;
            });
    }

    createCreatedForecastDataSource = (filterData: any) => {
        return this.agGridService.createDataSource(this.getCreatedForecasts, filterData);
    };

    getHistory(forecastId: number) {
        return this.apiClient.getForecastHistory(forecastId).then(response => {
            return response;
        });
    }

    getForecastProductCodes(changes: any, forecastYear?: number, forecastStatus?: string) {
        return this.apiClient
            .getForecastProductCodes({
                productCodes: changes,
                forecastYear: forecastYear ?? null,
                forecastStatus: forecastStatus as $TSFixMe
            })
            .then(response => {
                return response;
            });
    }

    searchProductCodes(searchString: string) {
        return this.apiClient.getForecastProductCode(searchString).then(response => {
            return response;
        });
    }
}

angular.module("topline.services").service(ForecastGridService.componentName, ForecastGridService);
